import angular from 'angular';
import 'angular-animate';
import '@uirouter/angularjs';

import './core';
import './shared';
import './layouts';

export const APP_MODULE = 'app';

angular.module(APP_MODULE, ['ui.router', 'ngAnimate', 'app.core', 'app.shared', 'app.layouts']);

export default APP_MODULE;
